import React from 'react';
import './PageNotFound.css';
const PageNotefound = () => {
    return (
        <div className='image'>
            <img src='https://www.seekpng.com/png/full/825-8253740_404-graphic-sorry-page-not-found.png' ></img>
        </div>
    );
};

export default PageNotefound;
